import script from "./ProductMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductMenu.vue?vue&type=script&setup=true&lang=ts"

import "./ProductMenu.vue?vue&type=style&index=0&id=7efa282d&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7efa282d"]])

export default __exports__